import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import React from "react";
import "./DeleteConfirmationModal.css";

interface DeleteConfirmationModalProps {
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
  itemName: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  onClose,
  onConfirm,
  isDeleting,
  itemName,
}) => {
  return (
    <Modal title={<>Confirm Deletion</>} onClose={onClose} size="medium">
<div className="modal-content legacy-modal-content">

        <p>
          Are you sure you want to delete the vendor "
          <strong>{itemName}</strong>"? This action cannot be undone.
        </p>
        <div className="modal-actions">
          <Button
            type="button"
            className="btn-cancel"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button variant="danger"
            type="button"
            className="btn-delete"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
        </div>
      </div>
</Modal>
  );
};

export default DeleteConfirmationModal;
